import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DownloadIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("polyline", {
    points: "17.91 9.97 11.92 16 5.93 10.02",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "11.92",
    y1: "4",
    x2: "11.92",
    y2: "15.29",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "18.91",
    y1: "20",
    x2: "4.91",
    y2: "20",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "2"
  })]
}), 'DownloadIcon');